import { render, staticRenderFns } from "./MuseumServicesPage.vue?vue&type=template&id=c3b25258&scoped=true&"
import script from "./MuseumServicesPage.vue?vue&type=script&lang=js&"
export * from "./MuseumServicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b25258",
  null
  
)

export default component.exports